import { Card } from 'external/react';
import PayoutsTable from './PayoutsTable';

const PayoutsPage = () => {
  return (
    <Card.Body>
      <PayoutsTable />
    </Card.Body>
  );
};

export { PayoutsPage as default };